export default "__VITE_ASSET__CDJVbYr7__"